import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import { categories } from '@/mocks/comics';

const values = [
  { icon: 'ri-compass-3-line', title: '高效发现', desc: '通过分类浏览、热门排行与新作推荐，帮你快速锁定想看的漫画，告别大海捞针。' },
  { icon: 'ri-book-open-line', title: '内容丰富', desc: '收录热血、恋爱、仙侠、悬疑等八大分类的连载与完结佳作，总有一部适合你。' },
  { icon: 'ri-sun-line', title: '更新及时', desc: '紧跟原作进度高频更新，热门连载不错过每一话，完结作品持续补全入库。' },
];

const steps = [
  { num: '01', title: '搜索定位', desc: '用站内搜索输入名称或关键词，秒级找到目标漫画。' },
  { num: '02', title: '分类筛选', desc: '在全部漫画页按分类和热度、更新、完结状态筛选。' },
  { num: '03', title: '开启阅读', desc: '进入作品页查看简介与章节目录，一键开始阅读。' },
];

export default function AboutPage() {
  return (
    <Layout>
      <section className="relative overflow-hidden bg-background-950 py-16 md:py-20">
        <img
          src="https://readdy.ai/api/search-image?query=anime%20manga%20desk%20scene%20with%20stacked%20comic%20books%20and%20a%20reading%20lamp%2C%20warm%20orange%20vermillion%20and%20amber%20tones%20on%20dark%20background%2C%20cozy%20atmosphere%2C%20stylized%20illustration%2C%20high%20detail&width=1600&height=700&seq=about-hero-2026&orientation=landscape"
          alt="4399漫画网阅读氛围图"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/60 to-background-950/85"></div>
        <div className="relative z-10 mx-auto max-w-3xl px-4 text-center md:px-6">
          <p className="flex items-center justify-center gap-2 text-sm font-medium text-secondary-300">
            <i className="ri-information-line"></i> 关于我们
          </p>
          <h1 className="mt-3 font-display text-3xl leading-tight text-background-50 md:text-5xl">关于 4399漫画网</h1>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
            4399漫画网是一个面向广大漫画爱好者的漫画阅读门户，致力于把「找漫画」这件小事做得更简单、更高效，让每一份热爱都有处安放。
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="font-display text-2xl text-foreground-900 md:text-3xl">我们为什么存在</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              海量的漫画资源让「想看什么」变成了一道难题。我们希望用清晰的分类、真实的排行和好用的搜索，帮助你快速找到下一部值得追的漫画，把时间留给真正精彩的故事。
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {values.map((v) => (
              <div key={v.title} className="rounded-lg border border-background-200 bg-background-100 p-6 text-center">
                <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-lg bg-secondary-100 text-xl text-secondary-700">
                  <i className={v.icon}></i>
                </span>
                <h3 className="mt-4 font-semibold text-foreground-900">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="font-display text-2xl text-foreground-900 md:text-3xl">三步开启追漫之旅</h2>
            <p className="mt-2 text-sm text-foreground-600">从发现到阅读，只需三个简单步骤。</p>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {steps.map((s) => (
              <div key={s.num} className="relative rounded-lg bg-background-50 p-6">
                <span className="font-display text-4xl text-primary-200">{s.num}</span>
                <h3 className="mt-2 font-semibold text-foreground-900">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
            <div>
              <h2 className="font-display text-2xl text-foreground-900 md:text-3xl">读者这样说</h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                我们很荣幸成为许多漫友每日光顾的「追漫第一站」。你的每一次阅读、每一句反馈，都是我们持续打磨体验的动力。
              </p>
              <Link to="/comics" className="mt-6 inline-block rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 whitespace-nowrap">
                去发现好漫画
              </Link>
            </div>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {[
                { name: '小满', text: '分类很清晰，完结作品库超级好逛，一口气看完好多本！' },
                { name: '阿泽', text: '热门排行很真实，跟着榜单追了几部，质量都在线。' },
                { name: '星星', text: '搜索很快，追更的作品更新也及时，体验很棒。' },
                { name: '墨白', text: '界面看着舒服，追漫效率高了不少，推荐给朋友了。' },
              ].map((t) => (
                <div key={t.name} className="rounded-lg border border-background-200 bg-background-100 p-5">
                  <div className="flex gap-1 text-secondary-500">
                    <i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">「{t.text}」</p>
                  <p className="mt-3 text-xs font-medium text-foreground-500">—— {t.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
            <div>
              <h2 className="font-display text-2xl text-foreground-900 md:text-3xl">联系我们</h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">关于网站的任何建议、问题与合作需求，欢迎随时联系我们。</p>
            </div>
            <div className="space-y-4 lg:col-span-2">
              {[
                { icon: 'ri-mail-line', label: '联系邮箱', value: 'contact@manga4399.site', href: 'mailto:contact@manga4399.site' },
                { icon: 'ri-wechat-line', label: '官方微信', value: '4399漫画网' },
              ].map((c) => (
                <div key={c.label} className="flex items-center gap-4 rounded-lg bg-background-50 p-5">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-lg text-primary-600">
                    <i className={c.icon}></i>
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500">{c.label}</p>
                    {c.href ? (
                      <a href={c.href} className="font-medium text-foreground-900 hover:text-primary-600">{c.value}</a>
                    ) : (
                      <p className="font-medium text-foreground-900">{c.value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于我们 - 4399漫画网',
            description: '4399漫画网是一个漫画阅读门户，提供分类浏览、热门排行、新上架作品与完结作品库等追漫服务。',
            isPartOf: { '@type': 'WebSite', name: '4399漫画网' },
          }),
        }}
      />
    </Layout>
  );
}